import calender from "assets/images/Wallet.svg";
import time from "assets/images/time.svg";
import { ViewDetail, ReceipeDetail } from "./style";
import receipe from "assets/images/receipe.svg";
import Button from "components/particles/primary-button";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSesssionDetails } from "./useHook";
import { useSelector } from "react-redux";

export default function Detail() {
  const { getSessionByUserById, generatePdfForUserSession } =
    useSesssionDetails();
  const [dishDetails, setDishDetails] = useState<any>({});
  const [pdfData, setPdfData] = useState<any>({});

  const location = useLocation();
  const { dishId, userId,sessionId } = location.state || {};
  

  useEffect(() => {
    if (dishId) {
      getSessionByUserById(userId, dishId,sessionId, setDishDetails);
    }
  }, [dishId]);
  const handlePrint = async (sessionId: any) => {
    const response = await generatePdfForUserSession(sessionId, setPdfData);
    if (response?.status) {
      window.open(response.pdfPath, "_blank");
    } else {
      console.error("Failed to generate PDF");
    }
  };

  return (
    <ViewDetail>
      <div className="title no-print">
        <h1>Preparation Detail</h1>
        <Button
          title="Donwload Pdf"
          width="16rem"
          fill="true"
          backgroundcolor="#007AFF"
          onclick={() => handlePrint(dishDetails[0].sessionId)}
        />
      </div>
      {dishDetails && Array.isArray(dishDetails) ? (
        dishDetails.map((item: any, dishIndex: number) => (
          <div className="print-container print-only content">
            <div className="view-detail-top-section">
              <div>
                <h2>{item?.homeCook?.homeCookName} </h2>
              </div>
              <div className="date-time-container">
                <div className="date-time">
                  <img src={calender} alt="img" />
                  <h1>
                    {new Date(
                      item.sessionDetails?.sessionDate
                    ).toLocaleDateString()}
                  </h1>
                </div>
                <div className="date-time">
                  <img src={time} alt="img" />
                  <h1>
                    {item.sessionDetails?.sessionTime &&
                      new Date(
                        `1970-01-01T${item.sessionDetails.sessionTime}`
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                  </h1>
                </div>
              </div>
            </div>
            <ReceipeDetail>
              <div>
                <h2>{item?.dish.dishName}</h2>
                <p>
                  {item?.dish.serving} Servings | Prep Time{" "}
                  {item?.dish.preparationTime} mins | Total Time: 1 Hour
                </p>
                <h1>Ingredients</h1>
                <ul style={{ listStyleType: "none" }}>
                  {item?.dish?.ingredients?.map((ing: any, index: number) => (
                    <li key={index}>{ing.ingredientName}</li>
                  ))}
                </ul>
                <h1>Pre-Cooking Steps</h1>
                <ul>
                  {item?.dish?.preCookingSteps
                    ?.split("\n")
                    .map((step: string, index: number) => (
                      <li key={index}>{step.replace(/^\d+\./, "").trim()}</li>
                    ))}
                </ul>
                <h1>Pre-Session Setup</h1>
                <ul>
                  {item?.dish?.preCookingSetUp
                    ?.split("\n")
                    .map((step: string, index: number) => (
                      <li key={index}>{step.replace(/^\d+\./, "").trim()}</li>
                    ))}
                </ul>
              </div>
              <div className="receipe-img">
                <img src={item?.dish?.coverImage[0]} alt="img" />
                <div className="receipe-img-detail">
                  {item?.dish?.dietaries?.map((dietary: any, index: number) => (
                    <div className="receipe-imag-detail-cart" key={index}>
                      <span
                        style={{
                          width: "27px",
                          height: "27px",
                          display: "flex",
                          borderRadius: "1rem",
                          border: "1px solid #808D9E",
                        }}
                      ></span>
                      <span>{dietary.dietaryName}</span>
                    </div>
                  ))}
                </div>
              </div>
            </ReceipeDetail>
          </div>
        ))
      ) : (
        <h1>Loading...</h1>
      )}
    </ViewDetail>
  );
}
